<template>
  <PageContent>
    <StepsV2 type="s3" :step="3" />
    <PanelV2
      type="w6"
      title="Provide a photo of your physical store"
      mode="submit"
      @nextClick="commitData"
    >
      <template v-slot:title-solt>
        <BdoProgress total="3" step="3" />
      </template>
      <template v-slot:content-solt>
        <IdCardUpload photoType="store" @exteriorImg="exteriorImg" @interiorImg="interiorImg" :photoData="formData" />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
  import IdCardUpload from "./common/IdCardUpload";
  import API from "@/api";
  export default {
    name: 'PartnershipK',
    pRouter: 'PartnershipJ',
    components: {
      IdCardUpload,
    },
    data() {
      return {
        formData: {
          interior: [],
          exterior: [],
        },
        formData2: {
          interior: [],
          exterior: [],
        }
      }
    },
    methods: {
      exteriorImg(val){
        this.formData2.exterior = val;
      },
      interiorImg(val){
        this.formData2.interior = val;
      },
      commitData() {
        const { interior, exterior } = this.formData2;
        if ((interior.length > 0) && (exterior.length >0)) {
          const data = this.formatCommitData({...this.formData2})

          API.addBdoProcess({
            ...data
          }).then(res => {
            if (res.success) {
              this.toNext()
            }
          })
        } else {
          this.showMessageTip('Upload photo of your store')
        }
      },
    }
  }
</script>


<style lang="scss" scoped>

</style>
